import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Contract} from '../../../shared/interface/contract';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ContractService} from '../../../shared/services/contract.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {
  CONTRACT_STATUS_DURING_TERMINATION, CONTRACT_STATUS_TERMINATED,
  CONTRACT_STATUS_TO_TERMINATE, CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_FRANCHISE, CONTRACT_TYPE_FRANCHISE_AGREEMENT, CONTRACT_TYPE_SELF_BILLING, CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_LEAD, CONTRACT_TYPE_LEASING, CONTRACT_TYPE_TERMINAL
} from "../../../shared/services/dict.service";

export interface ContractTerminateDialogData {
  contractObject: Contract;
}

@Component({
  selector: 'app-contract-terminate-dialog',
  templateUrl: './contract-terminate-dialog.component.html',
  styleUrls: ['./contract-terminate-dialog.component.scss']
})
export class ContractTerminateDialogComponent implements OnInit {
  readonly CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS = CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS;
  readonly CONTRACT_TYPE_FRANCHISE_AGREEMENT = CONTRACT_TYPE_FRANCHISE_AGREEMENT;
  readonly CONTRACT_TYPE_FRANCHISE = CONTRACT_TYPE_FRANCHISE;
  readonly CONTRACT_TYPE_SELF_BILLING = CONTRACT_TYPE_SELF_BILLING;
  readonly CONTRACT_TYPE_OCK = CONTRACT_TYPE_OCK;
  readonly CONTRACT_TYPE_LEAD = CONTRACT_TYPE_LEAD;
  readonly CONTRACT_TYPE_LEASING = CONTRACT_TYPE_LEASING;
  readonly CONTRACT_TYPE_TERMINAL = CONTRACT_TYPE_TERMINAL;

  contractObject: Contract;
  contract: ReplaySubject<Contract>;

  terminateForm: FormGroup;
  processingRequest = false;

  constructor(
    public dialogRef: MatDialogRef<ContractTerminateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContractTerminateDialogData,
    private fb: FormBuilder,
    private contractService: ContractService,
    private snack: MatSnackBar,
  ) {
    this.contractObject = data.contractObject;
    this.terminateForm = fb.group({
      terminationReason: fb.control('', [Validators.required]),
      reassignOfwca: fb.control(false),
    });
    this.contract = new ReplaySubject(1);
    this.contract.next(data.contractObject);
  }

  ngOnInit(): void {
  }

  terminate(): void {
    this.processingRequest = true;

    this.contractService.terminateContract(
      this.contractObject.uuid,
      this.terminateForm.value,
    ).subscribe(() => {
      this.snack.open('Umowa została przeniesiona do rozwiązania', '', {duration: 2000});
      this.dialogRef.close();
    }, (error: HttpErrorResponse) => {
      this.processingRequest = false;
      this.snack.open('Wystąpił błąd', error.status.toString(), {duration: 2000});
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
